<div id="office_search">
  <form>
    <tgf-form-control-question-processor
      [form]="questionForm"
      [questionJson]="questionJson"
      [parentModel]="actualModel"
      [questionsToSkip]="['office']">
    </tgf-form-control-question-processor>
    <p>Once you have completed the options above, click 'search offices'</p>
    <div class="d-flex">
      <button type="button" class="sd-btn sd-btn--action" (click)="search()" *ngIf="!isAutoSearch">
        Search Offices
      </button>
    </div>
    <p *ngIf="variablesService.officeValidated"
       class="success-message"
    ><i class="color-success fa-solid fa-circle-check me-2"
    ></i>Offices have been found that match your search, please select your office below.</p>
    <tgf-form-control-question-processor
      [parentModel]="actualModel"
      [questionsToInclude]="['office']"
      [form]="questionForm"
      [questionJson]="questionJson">
    </tgf-form-control-question-processor>
  </form>
  <p *ngIf="isValidOffice" class="success-message"><i class="color-success fa-solid fa-circle-check me-2"></i>Your
    office is valid</p>
</div>

<tg-spinner [blockAll]="true" *ngIf="isItLoading()"></tg-spinner>
